import Icon from '../components/Icon.vue'

Icon.register({
  skating: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 0C373.5 0 352 21.5 352 48S373.5 96 400 96 448 74.5 448 48 426.5 0 400 0zM400 448C391.2 448 384 455.2 384 464S376.8 480 368 480H272C263.2 480 256 487.2 256 496S263.2 512 272 512H368C394.5 512 416 490.5 416 464 416 455.2 408.8 448 400 448zM117.8 456.6C111.6 462.8 101.4 462.9 95.2 456.6L27.3 388.7C21.1 382.5 10.9 382.5 4.7 388.7S-1.5 405.1 4.7 411.3L72.6 479.2C82 488.6 94.3 493.2 106.6 493.2S131.2 488.5 140.5 479.2C146.7 473 146.7 462.8 140.5 456.6S124.1 450.3 117.8 456.6zM173.9 276.8L80.2 370.5C67.7 383 67.7 403.3 80.2 415.7 86.4 421.9 94.6 425.1 102.8 425.1S119.2 422 125.4 415.7L217.3 323.8 187.1 293.6C182.1 288.6 177.7 282.9 173.9 276.8zM128 160H233.5L213.4 177.2C199.9 188.7 191.8 205.6 191.1 223.3 190.4 241.1 197.2 258.5 209.8 271L288 349.2V432C288 449.7 302.3 464 320 464S352 449.7 352 432V342.6C352 330 346.9 317.6 337.9 308.7L276.9 247.7C277.4 247.3 278.1 247.1 278.6 246.6L360.9 164.3C372.4 152.8 375.8 135.7 369.6 120.7 363.4 105.7 348.9 96 332.6 96H128C110.3 96 96 110.3 96 128S110.3 160 128 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skating.js
// module id = mGwZ
// module chunks = 144